const { randomUUID } = require('@/utils');

/**
 * 获取唯一键配置
 * @typedef {Object} UniqueOptions
 * @property {number} row_index 行索引
 * @property {number} column_index 列索引
 * @property {string} property 列属性名
 * @property {string} custom_key 自定义键名
 */

/**
 * 获取唯一键
 * @param {UniqueOptions} config 配置
 * @returns {string}
 */
const getUniqueKey = ({ row_index, column_index, property, custom_key }) => {
  const keys = [row_index, column_index, property, custom_key];
  return keys.join('_');
};

/**
 * 获取Popover组件的ref名
 * @param {UniqueOptions} config 配置
 * @returns {string}
 */
const getPopoverRefKey = (config) => {
  return getUniqueKey({
    ...config,
    custom_key: `${randomUUID()}_table_el_popover_ref`,
  });
};

/**
 * 关闭Popover
 * @param {Object} s 组件实例对象
 * @param {string} key ref键名
 * @returns {void}
 */
const closePopover = (s, key) => {
  s.$refs[key].doClose?.();
};

/**
 * 显示Popover
 * @param {Object} s 组件实例对象
 * @param {string} key ref键名
 * @returns {void}
 */
const showPopover = (s, key) => {
  s.$refs[key].doShow?.();
};

module.exports = (s) => {
  return [
    {
      name: '收藏',
      width: 50,
      format: (row) => {
        const h = s.$createElement;
        const ele = h(
          'i',
          {
            class: `${row.top ? 'el-icon-star-on' : 'el-icon-star-off'} cursor-pointer w-full text-center`,
            style: `${row.top ? 'color: #E6A23C; font-size: 20px' : 'font-size: 16px'}`,
            on: {
              click: () => {
                s?.setTemplateTopStatus(row);
              },
            },
          },
          null,
        );

        return ele;
      },
    },
    {
      name: '模板名称',
      value: 'name',
      format: (row, column, _, row_index) => {
        const h = s.$createElement;
        const { id, name } = row;
        const { property } = column;
        const base_popover_options = {
          row_index,
          column_index: column.index,
          property,
        };
        const popover_ref_key = getPopoverRefKey(base_popover_options);
        const ele = h(
          'div',
          {
            class: 'flex justify-center items-center',
          },
          [
            h(
              'div',
              {
                class: 'ml-10 mr-10 min-w-0 truncate',
              },
              name,
            ),
            h(
              'el-popover',
              {
                ref: popover_ref_key,
                props: {
                  trigger: 'manual',
                },
              },
              [
                h(
                  'i',
                  {
                    slot: 'reference',
                    class: 'el-icon-edit-outline font-16',
                    on: {
                      click() {
                        s.closeAllTablePopover();
                        s.form_data_config.name.name.value = name;
                        showPopover(s, popover_ref_key);
                      },
                    },
                  },
                  null
                ),
                h(
                  'app-form',
                  {
                    props: {
                      formData: s.form_data_config.name,
                    },
                    on: {
                      cancel() {
                        closePopover(s, popover_ref_key);
                      },
                      async confirm(params) {
                        if (!params.name) {
                          s.$message.warning('请输入模板名称');
                          return;
                        }
                        await s?.editTemplateName(id, params);
                        closePopover(s, popover_ref_key);
                      },
                    },
                  },
                  null
                ),
              ]
            ),
          ]
        );
        return ele;
      },
    },
    {
      name: '模板保存时间',
      value: 'created_at',
      width: 140,
    },
    {
      name: '操作',
      width: 170,
      format: (row) => {
        const h = s.$createElement;
        const apply_button = h('el-button',
          {
            props: {
              type: 'primary',
              size: 'mini',
            },
            on: {
              click: () => {
                s.applicationTemplate(row);
              },
            },
          },
          '应用模板',
        );
        const delete_button = h('el-button',
          {
            props: {
              type: 'danger',
              size: 'mini',
            },
            on: {
              click: () => {
                s.onDeleteTemplate(row);
              },
            },
          },
          '删除'
        );
        return h('div', null, [apply_button, delete_button]);
      },
    },
  ];
};
